<script setup>
import { ref, watch, onMounted } from "vue";
import QRCode from "qrcode";

const props = defineProps({
  value: { type: String, required: true },  // text/URL to encode
  size: { type: Number, default: 192 },     // canvas size (px)
  margin: { type: Number, default: 2 },
  dark: { type: String, default: "#000000" },
  light: { type: String, default: "#FFFFFF" },
  errorCorrectionLevel: {
    type: String,
    default: "M", // L, M, Q, H
    validator: v => ["L","M","Q","H"].includes(v)
  }
});

const qrSrc = ref("");

async function render() {
  if (!props.value) {
    qrSrc.value = "";
    return;
  }
  qrSrc.value = await QRCode.toDataURL(props.value, {
    width: props.size,
    margin: 2,
    color: { dark: "#000000", light: "#ffffff" }
  });
}

onMounted(render);
watch(() => ({ ...props }), render, { deep: true });

defineExpose({ render });
</script>

<template>
  <div class="inline-flex flex-col items-start gap-2">
    <img :src="qrSrc" :width="size" :height="size" alt="QR Code" />
  </div>
</template>
